
import { petcoText, petcoWhite } from '@common/_assets/color-constants.js';

function padZero(str: any, len?: any) {
  len = len || 2;
  var zeros = new Array(len).join('0');
  return (zeros + str).slice(-len);
}
export namespace ColorUtils {
  export function invertColor(hex: string, bw: boolean, lightColor?: string, darkColor?: string) {
    if (hex.indexOf('#') === 0) {
      hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
      throw new Error('Invalid HEX color: ' + hex);
    }
    var r = parseInt(hex.slice(0, 2), 16),
      g = parseInt(hex.slice(2, 4), 16),
      b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
      // https://stackoverflow.com/a/3943023/112731
      return (r * 0.299 + g * 0.587 + b * 0.114) > 186
        ? (darkColor ?? petcoText)
        : (lightColor ?? petcoWhite);
    }
    // invert color components
    const red = (255 - r).toString(16);
    const green = (255 - g).toString(16);
    const blue = (255 - b).toString(16);
    // pad each with zeros and return
    return "#" + padZero(red) + padZero(green) + padZero(blue);
  }

  const componentFromStr = (numStr: string, percent: string) => {
    var num = Math.max(0, parseInt(numStr, 10));
    return percent ?
      Math.floor(255 * Math.min(100, num) / 100) : Math.min(255, num);
  }
  /**
   *  StackOverflow: //https://stackoverflow.com/a/13070569/2419089
   *  Converts an rgb(0,0,0) css color string to a hex color string #000000
   *  the hex string will be returned all upper case. This was to fix serialized colors not matching our #hex colors causing isDirty false positives.
   */
  export function rgbToHex(cssRgbString: string) {
    var rgbRegex = /^rgb\(\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*\)$/;
    var result, r, g, b, hex = "";
    if ((result = rgbRegex.exec(cssRgbString))) {
      r = componentFromStr(result[1], result[2]);
      g = componentFromStr(result[3], result[4]);
      b = componentFromStr(result[5], result[6]);

      hex = "#" + (0x1000000 + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
    }
    return hex;
  }


  /**
   * StackOverflow: https://stackoverflow.com/a/51567564/2419089
   *
   * Returns true if a color has a hrightness over 155 and false if it doesn't.
   * useful if you need to display text on a background color and need to flip between white/black text based on background color darkness.
   * @param colorHex a color hex rgb in #001952 format or 001952 format
   * @returns
   */
  export function isHexLightColor(colorHex: string) {
    if (colorHex === null || colorHex === undefined) return true;
    let hex = colorHex.replace("#", "");
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
      throw new Error('Invalid HEX color: ' + hex);
    }
    const c_r = parseInt(hex.substr(0, 2), 16);
    const c_g = parseInt(hex.substr(2, 2), 16);
    const c_b = parseInt(hex.substr(4, 2), 16);
    const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;
    return brightness > 155;
  }

}

export const invertColor = ColorUtils.invertColor;
